module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.89a317f.ttf";